export default __webpack_public_path__ + "static/media/fi-br-playing-cards-active.5a61c7de.svg";